// extracted by mini-css-extract-plugin
module.exports = {"container":"Score_container__1xnrb","innerContainer":"Score_innerContainer__3caGn","sum":"Score_sum__2kiHd"};